module.exports = __webpack_public_path__ + "img/文安机床与板材.3d869b65.jpg";